import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function sidebar(theme: Theme): ComponentStyle {
  return {
    componentName: 'sidebar',
    baseStyle: {
      minWidth: `calc(220px + ${theme.space.s})`,
      width: `calc(220px + ${theme.space.s})`,
      position: ['fixed', 'fixed', 'sticky'],
      backgroundColor: theme.colors.onSurface100,
      padding: theme.space.s,
      border: 'none'
    }
  };
}
